import TrendsLineChart from 'components/trends-line-chart/trends-line-chart.component';

const LoyaltyOfferTrendsLineChart = () => {
  return (
    <TrendsLineChart
      queryName="offersTrends"
      data-testid="LoyaltyOfferTrendsLineChart.IncLineChart"
      dataType="offerdatatype"
    />
  );
};

export default LoyaltyOfferTrendsLineChart;
